export enum SelectAddressDialogType {
  PickUpAddress = 'pickUpAddress',
  LocationAddresses = 'locationAddresses',
  DefaultAddress = 'defaultAddress',
  ExporterAddress = 'exporterAddress',
}
